<h1>Aanvraag verzonden</h1>
<p>De aanvraag is verzonden en wordt nu verwerkt. U kunt dit venster sluiten.</p>
<button mat-stroked-button color="primary" (click)="toHome()"><mat-icon>refresh</mat-icon>Nog een aanvraag doen</button>
